import axios from '../utils/axios';

export default function fetchActivityDetails(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/action-details', { params })
    )
}
